import { transformToMenu } from '../../../menus/graphql/transformers'

const transformToMenuScrapingTask = menuScrapingTask => ({
  ...menuScrapingTask,
  menu: transformToMenu(menuScrapingTask.menu),
})

export default transformToMenuScrapingTask
